import { createUseQuery } from 'api/common/createUseQuery'
import { Department, fetchDepartments } from 'api/fetchers/filters/fetchDepartments'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useDepartments = createUseQuery({
  queryKey: ApiQueryKeys.JOB_FAMILY_NAMES,
  fetcher: fetchDepartments,
  selector: res => (res?.data as Department[] | undefined) ?? ([] as Department[]),
})
